<script lang="ts">
  import { AppState } from '../../etc/stores';

  const color = $AppState.theme.colors.primary200;
</script>

<div
  class="twism-circle-container"
  style="background: linear-gradient(180deg, {color}14 11.76%, rgba(255, 255, 255, 0) 51.54%);"
/>
<div
  class="twism-circle-container__second"
  style="background: linear-gradient(180deg, {color}26 5.79%, rgba(255, 255, 255, 0) 54.18%);"
/>
<div
  class="twism-circle-container__third"
  style="background: linear-gradient(180deg, {color}1A 0%, rgba(255, 255, 255, 0) 76.15%);"
/>

<style lang="scss">
  .twism-circle-container {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    width: 374.07px;
    height: 374.07px;

    opacity: 0.8;
    border-radius: 300px;

    &__second {
      display: flex;
      align-items: center;
      justify-content: center;

      position: absolute;
      width: 261.5px;
      height: 261.5px;
      left: 65px;
      top: 50px;

      opacity: 0.5;
      border-radius: 300px;
    }
    &__third {
      display: flex;
      align-items: center;
      justify-content: center;

      position: absolute;
      width: 148.92px;
      height: 148.92px;
      left: 121px;
      top: 109px;

      opacity: 0.5;
      border-radius: 300px;
    }
  }
</style>
